var exports = {
  "k": "xb99ab02a--08e96c--container",
};

module.exports = exports;
